<template>
  <iMineTemplate :page-title="pageTitle" :actived-parent-key="activedParentKey" :actived-key="activedKey">
    <div slot="rightContent" class="mycollection">
      <div class="collection">收藏的商品</div>
      <div
        style="display: flex; flex-wrap: wrap; padding: 10px';;"
      >
        <div
          v-for="goods in dataList"
          :key="goods.Id"
          class="item"
          @click.stop="showRouter(goods)"
        >
          <!-- list 组件(普通活动样式，适用于宫格) -->
          <NewProductItem
            ref="NewProductItem"
            :product="goods"
          />
        </div>
      </div>

    </div>
  </iMineTemplate>
</template>

<script>

import { BaseMixin } from '../../mixins/BaseMixin'

export default {
  name: 'MyCollection',
  components: {

  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['我的收藏', '收藏的商品'],
      activedParentKey: 3,
      activedKey: 32,
      Offset: 0,
      finished: false,
      IsHasNext: false,
      dataList: [],
      url: {
        list: '/api_customer/CustomerCollect/List?enumCollectType=1'
      }
    }
  },
  async mounted() {
    this.loadData()
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  methods: {
    showRouter: function(item) {
      this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, '_blank')
    },
    async loadData() {
      this.$hys.openLoading()
      const res = await this.getAction(this.url.list, {
        Offset: this.Offset
      })
      this.$hys.clearLoading()
      this.totalCount = res.Count
      if (res.IsSuccess && res.Data.length < this.pageSize) {
        this.finished = true
      }
      if (res.IsSuccess) {
        const dataArr = []

        res.Data.GoodsList.map(item => {
          dataArr.push(item)
        })
        this.dataList = dataArr
        // 保存分页标记，由后端返回，第一次第一页，前端默认传递0 （偏移量）
        this.Offset = res.Data.Offset
        // 保存是否分页标记
        this.IsHasNext = res.Data.IsHasNext
      } else {
        this.finished = true
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录
      if (scrollTop > 600) {
        this.isFixedMenu = true
      } else {
        this.isFixedMenu = false
      }
      // 到达页面底部时
      if ((scrollTop + clientHeight >= scrollHeight - 400) && this.IsHasNext) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        // 开启加载层
        this.$hys.openLoading()
        this.IsHasNext = false
        // 延时请求
        this.timer = setTimeout(() => {
          // 获取list
          this.getActivityList()
        }, 100)
      }
    }

  }
}
</script>

<style lang="less" scoped>
.mycollection {
  width: 104%;
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // left: 20px;
  // right: 0;
  background: rgba(255, 255, 255, 1);

  .collection {
    padding-top: 20px;
    padding-left: 20px;
    font-size: 18px;
    text-align: left;
    color: #222222;
    color: rgba(34, 34, 34, 1);
    background-color: #FFFFFF;
    box-sizing: border-box;
  }

  .item {
    margin: 4px 0;
    width: 240px;
  }
}
</style>
